'use client';

import clsx from 'clsx';
import { useRef } from 'react';
import { twMerge } from 'tailwind-merge';

import { useIsOverflow } from '@/app/lib/hooks/use-is-overflow';

import { ModalButtonsWrapper } from './buttons';

import type { ReactNode, UIEventHandler } from 'react';

export const BaseModalContent = ({
  buttonComponent,
  children,
  handleHasOverflow,
  hideScrollbar = true,
  onScroll,
}: {
  buttonComponent: ReactNode;
  children?: ReactNode;
  handleHasOverflow?: (hasOverflow: boolean) => void;
  hideScrollbar?: boolean;
  onScroll?: UIEventHandler<HTMLDivElement>;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  useIsOverflow({
    ref,
    callback: handleHasOverflow,
  });

  return (
    <>
      {children ? (
        <div
          ref={ref}
          onScroll={onScroll}
          data-testid="modal-content"
          className={twMerge(
            clsx(
              'flex grow flex-col gap-e overflow-y-auto p-e md:gap-d lg:p-d',
              {
                'no-scrollbar': hideScrollbar,
              }
            )
          )}
        >
          {children}
        </div>
      ) : null}
      <ModalButtonsWrapper hasBaseContent={Boolean(children)}>
        {buttonComponent}
      </ModalButtonsWrapper>
    </>
  );
};
